import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';

import { TextButton } from 'components/core';
import { bold } from 'components/core/typography';
import SvgGreenCheck from 'src/assets/green-check';

import { DispensaryInfo } from '../../components/dispensary-info';
import { CurrentlySelectedProps } from '../../select-store.types';

export function CurrentlySelected({ selectedStore, handleClearSelection }: CurrentlySelectedProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Container>
      <Header>{t('currently-selected', 'Currently Selected')}</Header>
      {selectedStore ? (
        <SelectionContainer>
          <DispensaryInfo dispensary={selectedStore} isDesktop />
          <TextButton onClick={handleClearSelection}>{t('clear-selection', 'Clear Selection')}</TextButton>
        </SelectionContainer>
      ) : (
        <NoSelectionContainer>
          <StyledGreenCheck width={14} height={11.45} viewBox='0 0 10 10' />
          <AllStores>{t('all-stores', 'All Nearby Stores')}</AllStores>
        </NoSelectionContainer>
      )}
    </Container>
  );
}

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.primaryGrey};
  border-radius: 14px;
  text-align: left;
  padding: 19px;
  margin: 0px 30px 20px;
  flex-shrink: 0;
`;

const SelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Header = styled.div`
  font-size: 13px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.grey[45]};
  padding-bottom: 13px;
  ${bold};
`;

const NoSelectionContainer = styled.div``;

const AllStores = styled.span`
  ${bold};
`;

const StyledGreenCheck = styled(SvgGreenCheck)`
  margin-right: 10px;
`;
